import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        px: 3,
        textAlign: "center",
        background: "#F4F7FA",
        fontFamily: FONT,
        color: "#0F1B2A",
      }}
    >
      <Typography
        variant="h2"
        sx={{ fontFamily: FONT, fontSize: { xs: 44, sm: 56 }, fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 1, color: "#0F1B2A" }}
      >
        OOPS!
      </Typography>

      <Typography
        variant="h6"
        sx={{ fontFamily: FONT, fontSize: 15, fontWeight: 500, color: "#4A5A6E", maxWidth: 360, textWrap: "pretty" }}
      >
        It seems something went wrong, go back to dashboard
      </Typography>

      <Button
        className="btn-contained"
        onClick={() => navigate("/")}
        sx={{
          mt: 1,
          height: 44,
          px: 3,
          borderRadius: "10px !important",
          background: "#0B5C8A !important",
          color: "#FFFFFF !important",
          border: "0 !important",
          fontFamily: FONT,
          fontSize: 14,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": { background: "#084767 !important" },
        }}
      >
        Go To Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;
